import { Injectable } from '@angular/core'

import { EmailTemplate } from './email-template'

@Injectable()
export class EmailTemplateSerializer {
  fromJson(json: any): EmailTemplate {
    const emailTemplate = {
      ...json
    }

    return emailTemplate
  }

  toJson(emailTemplate: EmailTemplate): any {
    return {
      ...emailTemplate
    }
  }
}
